module.exports = __webpack_public_path__ + "static/img/2023年历-12.48aca3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2023年历-12.jpg
// module id = mx8u
// module chunks = 3